import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { HostService } from '../host/host.service';

@Injectable({
	providedIn: 'root'
})
export class NotasService {

	host = this.hostService.host;
	actualizar_actitudinal = 'actitudinal/actualizar/'
	nueva_actitudinal = 'actitudinal/'
	actualizar_notas = 'notas/actualizar/'

	constructor(public http: HttpClient, public hostService: HostService) { }

	actualizarActitudinal(codigo: any, data: any): Promise<any> {
		return new Promise((resolve, reject) => {
			if (codigo == 'nuevo') {
				this.http.post(`${this.host}${this.nueva_actitudinal}${codigo}`, data)
				.subscribe(
					data => {
						resolve(data);
					},
					error => {
						reject(error);
					}
				)
			} else {
				this.http.put(`${this.host}${this.actualizar_actitudinal}${codigo}`, data)
					.subscribe(
						data => {
							resolve(data);
						},
						error => {
							reject(error);
						}
					)
			}
		})
	}

	actualizarNotaLogro(periodo: any, data: any): Promise<any> {
		return new Promise((resolve, reject) => {
			this.http.put(`${this.host}${this.actualizar_notas}${periodo}`, data)
				.subscribe(
					data => {
						resolve(data);
					},
					error => {
						reject(error);
					}
				)
		})
	}

}
